import VMultiFileUpload from './index.vue';

export default {
  install: (Vue) => Vue.component('VMultiFileUpload', VMultiFileUpload),
};
